import { Controller } from "@hotwired/stimulus";
import categories from "../../constants/advertising_iab_categories.json";
export default class extends Controller {
  static values = { categoryPlaceholder: String }

  static targets = [
    "shortLinkInput", "shortLinkBtn", "shortLinkText", "shortLinkSpin", "shortLinkContainer", "shortLinkLink", "copy", "copied", "shortLinkError",
    "shortLinkResultBox", "shortLinkShareBtn", "shortLinkCopyBtn", "downloadQrContainer", "categorySelect", "shortLinkFieldBox"
  ]

  connect() {
    const select = this.categorySelectTarget;
    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = this.categoryPlaceholderValue;
    select.appendChild(placeholder);
    categories.forEach(({ id, name }) => {
      const option = document.createElement("option");
      option.value = id;
      option.textContent = name;
      select.appendChild(option);
    });
  }

  generateLink() {
    const linkValue = this.normalizeUrl(this.shortLinkInputTarget.value);
    this.shortLinkInputTarget.value = linkValue;

    if (!this.isValidUrl(linkValue)) {
      this.shortLinkFieldBoxTarget.classList.add("border-danger")
      this.shortLinkInputTarget.setAttribute("aria-invalid", "true")
      this.shortLinkErrorTarget.classList.remove("d-none")
      setTimeout(() => {
        this.shortLinkFieldBoxTarget.classList.remove("border-danger")
        this.shortLinkInputTarget.removeAttribute("aria-invalid")
        this.shortLinkErrorTarget.classList.add("d-none")
      }, 3000);
      return;
    }

    const formData = new FormData();
    formData.append("link", linkValue);
    const categoryId = this.categorySelectTarget.value;
    if (categoryId) {
      formData.append("advertisingIabCategories[]", categoryId);
    }
    formData.append("force_create", true);
    formData.append("qrTitle", "Short Link");
    formData.append("type", "56");

    this.shortLinkBtnTarget.disabled = true;
    this.shortLinkSpinTarget.classList.remove("d-none")
    this.shortLinkTextTarget.classList.add("d-none")

    fetch("/link/ajax/new", {
      method: "POST",
      body: formData,
    })
      .then(res => res.json())
      .then(data => {
        if (!data.url) {
          throw new Error('Short link creation failed: ' + JSON.stringify(data));
        }

        window.gtag?.("event", "create_slink");
        this.sendYahooShortLinkConversion();

        this.shortLinkLinkTarget.innerText = data.url
        this.shortLinkLinkTarget.classList.remove('text-light-gray');
        this.shortLinkLinkTarget.classList.add('text-secondary');
        this.shortLinkContainerTarget.classList.remove("d-none");
        this.shortLinkResultBoxTarget.classList.remove('bg-gray-light');
        this.shortLinkResultBoxTarget.classList.add('bg-short-link');
        this.shortLinkShareBtnTarget.disabled = false;
        this.shortLinkShareBtnTarget.classList.remove('border', 'border-light-gray', 'text-light-gray');
        this.shortLinkShareBtnTarget.classList.add('btn-outline-secondary');
        this.shortLinkCopyBtnTarget.disabled = false;
        this.shortLinkCopyBtnTarget.classList.remove('bg-light-gray', 'border', 'border-light-gray', 'text-white');
        this.shortLinkCopyBtnTarget.classList.add('btn-secondary', 'text-white');
        this.mountDownloadQrButton(data);
        this.updateShareLinks(data.url);
        if (document.cookie.split(';').some(c => c.trim().startsWith('folderId='))) {
          document.cookie = 'folderId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        }
      })
      .catch(err => console.error(err))
      .finally(() => {
        this.shortLinkBtnTarget.disabled = false;
        this.shortLinkSpinTarget.classList.add("d-none")
        this.shortLinkTextTarget.classList.remove("d-none")
      });
  }

  sendYahooShortLinkConversion() {
    window.ytag?.({
      type: "yss_conversion",
      config: {
        yahoo_conversion_id: "1001407004",
        yahoo_conversion_label: "n3HHCNTQoYEdEPTnqqhE",
        yahoo_conversion_value: "1",
      },
    });
  }

  mountDownloadQrButton(data) {
    const container = this.downloadQrContainerTarget;
    const trans = JSON.parse(container.dataset.trans);
    const qrEl = document.createElement('div');
    qrEl.setAttribute('data-controller', 'react--component');
    qrEl.setAttribute('data-react--component-path-value', 'components/admin/downloadQrButton/index');
    qrEl.setAttribute('data-react--component-props-value', JSON.stringify({
      trans,
      qrDescription: '{}',
      qrLink: data.url,
      title: 'Short Link',
      id: data.id,
    }));
    qrEl.className = 'd-flex justify-content-center align-items-center h-100';
    container.innerHTML = '';
    container.appendChild(qrEl);
  }

  updateShareLinks(url) {
    const encoded = encodeURIComponent(url);
    document.querySelectorAll('[data-share-platform]').forEach(a => {
      const template = a.dataset.shareUrlTemplate;
      if (template) {
        a.href = template.replace('{url}', encoded);
      } else {
        a.onclick = async (e) => {
          e.preventDefault();
          if (navigator.share) {
            try {
              await navigator.share({ url });
            } catch (err) {
              if (err.name !== 'AbortError') console.error(err);
            }
          } else {
            await navigator.clipboard.writeText(url);
          }
        };
      }
    });
  }

  isValidUrl(url) {
    if (url === "" || /\s/.test(url) || !/^[\x00-\x7F]+$/.test(url)) {
      return false;
    }

    try {
      const parsedUrl = new URL(url);
      const isHttpUrl = parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
      const hostLabels = parsedUrl.hostname.toLowerCase().split(".");
      const hasValidHost = hostLabels.length > 1 && hostLabels.every(label => (
        label !== "" &&
        !label.startsWith("xn--") &&
        /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(label)
      ));

      return isHttpUrl && hasValidHost;
    } catch (_) {
      return false;
    }
  }
  normalizeUrl(url) {
    const trimmedUrl = url.trim();

    if (trimmedUrl === "" || /^https?:\/\//i.test(trimmedUrl)) {
      return trimmedUrl;
    }

    return `https://${trimmedUrl}`;
  }
  clearField(){
    this.shortLinkInputTarget.value = ""
  }
  copy() {
    const content = this.shortLinkLinkTarget.innerText;
    if (!content) return;
    window.gtag?.("event", "copy_link_click");
    navigator.clipboard.writeText(content).then(() => {

      this.copyTarget.classList.add("d-none")
      this.copiedTarget.classList.remove("d-none")

      setTimeout(() => {
        this.copyTarget.classList.remove("d-none")
        this.copiedTarget.classList.add("d-none")
      }, 3500);
    });
  }

  shareLink() {
    window.gtag?.("event", "share_link_click");
  }
}
